var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{class:{ success: _vm.success, error: _vm.error, default: !_vm.success && !_vm.error }},[_c('div',{staticClass:"status-icon"},[_c('SvgIcon',{attrs:{"name":_vm.icon}})],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }